module.exports = __webpack_public_path__ + "static/media/ic_launcher_round.b1bdeaf9.png";